<template>
  <div class="row">
    <div class="col-md-6">
      <div class="client_card">
        <clientCard
          ref="clientForm"
          :client="client"
          :search="false"
          :phones="client && client.phones || null"
          :updateClient="updateClient"
        />
      </div>
    </div>
    <div class="col-md-6">
      <input v-model="order.comment" placeholder="Комментарий к заявке" class="form-control mb-1">
      <input v-model="order.address" placeholder="Адрес" class="form-control">
      <div class="form-group">
        <label for="">Дата планируемой доставки</label>
        <datetime
          input-class="form-control"
          type="date"
          :minute-step="60"
          format="dd.MM.yyyy (cccc)"
          :auto="true"
          :min-datetime="minDateSelect"
          :max-datetime="maxDateSelect"
          v-model="deliveryDate"></datetime>
      </div>
    </div>
    <div class="col-md-9">
      <smallFormSelectDrugsWithPrice
        ref="drugsSelected"
        :drugsUpdated="drugsUpdated"
      />
    </div>
    <div class="col-md-3 price_fields">
      <p class="text-right">Стоимость препаратов</p>
      <input disabled v-model="figures.totalPrice" class="form-control">
      <div v-if="rates">
        <p class="text-right">Кросс курс</p>
        <input disabled v-model="rates[exportCurrencyId]" class="form-control">
        <p class="text-right">Просчетная стоимость</p>
        <input disabled :value="Math.round(figures.totalPrice * rates[exportCurrencyId] * 10)/10" class="form-control">
      </div>
    </div>
    <div class="col-md-12 text-right mt-2">
      <vue-ladda @click="createNewOrder" button-class="btn btn-success"
                 data-style="zoom-in"
                 :loading="loading">Создать заявку
      </vue-ladda>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import clientCard from "../clients/clientCard";
import smallFormSelectDrugsWithPrice from "./smallFormSelectDrugsWithPrice";
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import {Datetime} from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import moment from 'moment'

export default {
  components: {
    clientCard,
    smallFormSelectDrugsWithPrice,
    VueLadda,
    Datetime,
  },
  props: ['rates', 'orderUpdated', 'byAgentReSeller'],
  data() {
    return {
      loading: false,
      exportCurrencyId: 38,
      figures: {
        totalPrice: 0,
      },
      drugs: [],
      order: {},
      client: null,
      deliveryDate: null,
      minDateSelect: moment().add(1, 'days').format(),
      maxDateSelect: moment().add(20, 'days').format(),
    }
  },
  methods: {
    resetOrder(order = null) {
      this.drugs = [];
      this.order = {};
      this.client = null;
      this.figures.totalPrice = 0;
      if (this.orderUpdated) {
        this.orderUpdated(order);
      }
    },
    async createNewOrder() {
      let err = false;
      // if (!this.client || !this.client.id) {
      //   toastr['warning']('Вы не выбрали или не подтвердили клиента!');
      //   err = true;
      // }
      if (!this.order.address) {
        toastr['warning']('Вы не указали адрес доставки');
        err = true;
      }
      if (!this.deliveryDate) {
        toastr['warning']('Вы не указали дату доставки');
        err = true;
      }
      const drugsCheck = this.drugs.filter((d) => d.id);
      const drugsCheckQty = this.drugs.filter((d) => (d.id && d.qty <= 0));
      if (!this.drugs.length || !drugsCheck.length || drugsCheckQty.length) {
        toastr['warning']('Отсутвуют препараты в заявки или количество препаратов недопустимо');
        err = true;
      }

      const client = this.$refs.clientForm.forEdit;

      if (client) {
        if (!client.client || !client.client.name) {
          toastr['warning']('Вы не выбрали клиента!');
          err = true;
        }
        if (!client.phones.length || !client.phones[0].phone || !client.phones[0].phone.full_phone) {
          toastr['warning']('Вы не выбрали телефон!');
          err = true;
        }
      } else {
        toastr['warning']('Вы не выбрали клиента!');
      }
      if (err) return;
      this.loading = true;
      let {data} = await api.post('/orders/createNewOrder', {
        order: {...this.order, type_id: 3, delivery_date: this.deliveryDate},
        drugs: this.drugs,
        client: client,
        byAgentReSeller: this.byAgentReSeller || false
      });
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка!');
      } else {
        toastr['success'](data.message || 'Заявка создана!');
        this.resetOrder(data.order);
      }
      this.loading = false;
    },
    updateClient(client, phone) {
      this.client = client;
      this.client.phones = phone;
    },
    drugsUpdated() {
      let drugs = this.$refs.drugsSelected.drugs;
      this.drugs = [...drugs];
      this.figures.totalPrice = 0;
      drugs.forEach((d) => {
        this.figures.totalPrice += d.qty * d.price;
      })
    }
  }
}

</script>

<style>
.client_card {
  padding-bottom: 10px;
}

.price_fields p {
  margin-bottom: 2px;
}
</style>
